import React from 'react';

const CreditsBackground = () => {
  return (
    <div className="thematic-bg-container credits-bg">
      <div className="starfield"></div>
      <div className="horizon-glow"></div>
      <div className="the-end-text">FIN.</div>
    </div>
  );
};

export default CreditsBackground;
